import React, { useState, useEffect, useContext } from "react";
import Sidebar from "../sidebar";
import { useNavigate } from "react-router-dom";
import { ProgressContext } from "../ContextAPI";
import "./ExcutiveCompensation.css";
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  FormControlLabel,
  RadioGroup,
  Radio,
  Grid,
} from "@mui/material";
import { api, get, post, put } from "../../../utils/api";
import ActionButtons from "../InitialKickoff/MaterialTopics/ActionButtons";
import { textError, percentageError } from "../../../utils/validationMessage";
import SkipQuestionare from "../../Common/SkipQuestionare";
import InitialQuestionareSidebar from "../../../Layout/InitialQuestionareSidebar";
import { getQuestionareSubmitted } from "../../../utils/storage";

const ExclutiveCompensation = () => {
  const companyDetails = getQuestionareSubmitted();

  const { setUpdate } = useContext(ProgressContext);
  const navigate = useNavigate();
  const [isExist, setIsExist] = useState(false);
  const [formData, setFormdata] = useState({
    ceoPayRatio: {
      ceo_pay: 0,
      median_emp_pay: 0,
    },
    linkageExecutiveCompensationEsgPerformance: {
      radio: "yes",
      brief: "",
    },
  });
  const [errors, setErrors] = useState({});
  const validateForm = () => {
    const newErrors = {};

    const { ceoPayRatio, linkageExecutiveCompensationEsgPerformance } =
      formData;

    // Validate `ceoPayRatio`
    if (
      formData.ceoPayRatio.ceo_pay !== "" &&
      formData.ceoPayRatio.ceo_pay !== null
    ) {
      const ceoPay = Number(formData.ceoPayRatio.ceo_pay);
      if (
        isNaN(ceoPay) ||
        !/^\d{1,3}(\.\d+)?$/.test(formData.ceoPayRatio.ceo_pay) ||
        ceoPay < 0 ||
        ceoPay > 100
      ) {
        newErrors.ceoPayRatioCeoPay = percentageError;
      }
    }

    if (
      formData.ceoPayRatio.median_emp_pay !== "" &&
      formData.ceoPayRatio.median_emp_pay !== null
    ) {
      const medianPay = Number(formData.ceoPayRatio.median_emp_pay);
      if (
        isNaN(medianPay) ||
        !/^\d{1,3}(\.\d+)?$/.test(formData.ceoPayRatio.median_emp_pay) ||
        medianPay < 0 ||
        medianPay > 100
      ) {
        newErrors.ceoPayRatioMedianEmpPay = percentageError;
      }
    }

    if (
      linkageExecutiveCompensationEsgPerformance.radio === "yes" &&
      (!linkageExecutiveCompensationEsgPerformance.brief ||
        linkageExecutiveCompensationEsgPerformance.brief.trim() === "")
    ) {
      newErrors.linkageExecutiveCompensationEsgPerformanceBrief = textError;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    setUpdate("GOVERNANCE");
    get(`${api}/governance/excutive-compensation`)
      .then((res) => {
        console.log(
          res,
          res.data.linkageExecutiveCompensationEsgPerformance.radio
        );
        setFormdata({
          ceoPayRatio: {
            ceo_pay: res.data.ceoPayRatio.ceo_pay,
            median_emp_pay: res.data.ceoPayRatio.median_emp_pay,
          },
          linkageExecutiveCompensationEsgPerformance: {
            radio:
              res.data.linkageExecutiveCompensationEsgPerformance.radio === true
                ? "yes"
                : "no",
            brief: res.data.linkageExecutiveCompensationEsgPerformance.brief,
          },
        });
        setIsExist(true);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormdata({
  //     ...formData,
  //     ceoPayRatio: {
  //       ...formData.ceoPayRatio,
  //       [name]: value,
  //     },
  //   });
  //   console.log(name, value);
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormdata({
      ...formData,
      ceoPayRatio: {
        ...formData.ceoPayRatio,
        [name]: value,
      },
    });

    // Clear specific error
    if (name === "ceo_pay") {
      setErrors((prev) => ({ ...prev, ceoPayRatioCeoPay: "" }));
    } else if (name === "median_emp_pay") {
      setErrors((prev) => ({ ...prev, ceoPayRatioMedianEmpPay: "" }));
    }
  };

  const handleChangeRadio = (e) => {
    const { name, value } = e.target;
    setFormdata({
      ...formData,
      linkageExecutiveCompensationEsgPerformance: {
        ...formData.linkageExecutiveCompensationEsgPerformance,
        [name]: value,
      },
    });
    console.log(e.target.value);
  };

  const Save = async () => {
    if (!validateForm()) {
      return;
    }

    let method = isExist ? put : post;
    let url = `/governance/excutive-compensation`;

    const { ceoPayRatio, linkageExecutiveCompensationEsgPerformance } =
      formData;

    const hasValidCEO =
      ceoPayRatio?.ceo_pay !== undefined && ceoPayRatio?.ceo_pay !== "";
    const hasValidMedian =
      ceoPayRatio?.median_emp_pay !== undefined &&
      ceoPayRatio?.median_emp_pay !== "";
    const hasValidRadio =
      linkageExecutiveCompensationEsgPerformance?.radio?.trim() !== "";

    const executive_compensation =
      hasValidCEO && hasValidMedian && hasValidRadio;
    const payload = {
      ...formData,
      executive_compensation,
    };
    await method(url, payload)
      .then((res) => {
        navigate(
          companyDetails?.questionareSubmitted
            ? "/preview"
            : "/governance/ethics"
        );
      })
      .catch((err) => {
        alert(err.message);
      });
  };

  const Back = () => {
    navigate("/governance/board-composition");
  };

  return (
    <Box sx={{ display: "flex", backgroundColor: "#EDEDED", height: "100vh" }}>
      <Box
        sx={{
          width: "25vw",
          // overflowY: "auto",
        }}
      >
        <InitialQuestionareSidebar />
      </Box>
      <Box
        sx={{
          p: 2,
          mt: 3,
          width: "75vw",
          height: "100vh", // Full viewport height
          overflowY: "auto", // Allow vertical scrolling if content exceeds viewport
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start", // Adjust to start at the top of the box
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "80%",
            marginBottom: "1rem",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              zIndex: 1,
              padding: "10px 0px",
              borderRadius: "4px",
              alignSelf: "flex-start",
            }}
          >
            GOVERNANCE: EXECUTIVE COMPENSATION
          </Typography>
          <SkipQuestionare />
        </div>

        <Box sx={{ width: "80%" }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", mb: 1, mt: 2 }}
            gutterBottom
          >
            CEO Pay Ratio
          </Typography>

          <Grid
            item
            xs={12}
            md={12}
            gap={1}
            width={"100%"}
            className="CEOPay"
            alignItems="center"
          >
            {/* <Grid item xs={12} md={6}> */}
            <Box sx={{ width: "100%" }}>
              <TextField
                variant="outlined"
                placeholder="CEO Pay"
                // className="inputfieldPay"
                name="ceo_pay"
                value={
                  formData.ceoPayRatio.ceo_pay === 0
                    ? ""
                    : formData.ceoPayRatio.ceo_pay
                }
                onChange={handleChange}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Box
                          sx={{
                            height: "30px",
                            width: "1px",
                            bgcolor: "#6b6c6d",
                            marginRight: "8px",
                          }}
                        />
                        %
                      </Box>
                    </InputAdornment>
                  ),
                  style: {
                    borderColor: errors.ceoPayRatioCeoPay
                      ? "#D34040"
                      : undefined,
                  },
                }}
                sx={{ marginRight: "5px", width: "100%" }}
                error={!!errors.ceoPayRatioCeoPay} // Show error styling if there's an error
                InputLabelProps={{
                  style: {
                    color: errors.ceoPayRatioCeoPay ? "#D34040" : undefined,
                  },
                }}
              />
              {errors.ceoPayRatioCeoPay && (
                <Typography variant="body2" color="#D34040">
                  {errors.ceoPayRatioCeoPay}
                </Typography>
              )}
            </Box>
            :
            <Box sx={{ width: "100%" }}>
              <TextField
                variant="outlined"
                placeholder="Median Employee Pay"
                // className="inputfieldPay"
                name="median_emp_pay"
                value={
                  formData.ceoPayRatio.median_emp_pay === 0
                    ? ""
                    : formData.ceoPayRatio.median_emp_pay
                }
                onChange={handleChange}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Box
                          sx={{
                            height: "30px",
                            width: "1px",
                            bgcolor: "#6b6c6d",
                            marginRight: "8px",
                          }}
                        />
                        %
                      </Box>
                    </InputAdornment>
                  ),
                  style: {
                    borderColor: errors.ceoPayRatioMedianEmpPay
                      ? "#D34040"
                      : undefined,
                  },
                }}
                sx={{ marginRight: "5px", width: "100%" }}
                error={!!errors.ceoPayRatioMedianEmpPay} // Show error styling if there's an error
                InputLabelProps={{
                  style: {
                    color: errors.ceoPayRatioMedianEmpPay
                      ? "#D34040"
                      : undefined,
                  },
                }}
              />
              {errors.ceoPayRatioMedianEmpPay && (
                <Typography variant="body2" color="#D34040">
                  {errors.ceoPayRatioMedianEmpPay}
                </Typography>
              )}
            </Box>
            {/* </Grid> */}
          </Grid>

          <Typography
            variant="subtitle1"
            className="paragraph"
            sx={{ fontWeight: "bold", mb: 1 }}
            gutterBottom
            mt={2}
          >
            Linkage of Executive Compensation to ESG Performance
          </Typography>

          <RadioGroup
            className="radiobutton"
            name="radio"
            value={formData.linkageExecutiveCompensationEsgPerformance.radio}
            onChange={handleChangeRadio}
            row
          >
            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="no" control={<Radio />} label="No" />
          </RadioGroup>
          {formData.linkageExecutiveCompensationEsgPerformance.radio ===
          "yes" ? (
            <Box>
              <TextField
                rows={5}
                multiline
                placeholder="Brief"
                className="brief"
                name="brief"
                value={
                  formData.linkageExecutiveCompensationEsgPerformance.brief
                }
                onChange={(e) => {
                  handleChangeRadio(e);
                  setErrors({
                    ...errors,
                    linkageExecutiveCompensationEsgPerformanceBrief: "",
                  });
                }}
                style={{ width: "100%", marginTop: "15px" }}
                InputProps={{
                  style: {
                    borderColor:
                      errors.linkageExecutiveCompensationEsgPerformanceBrief
                        ? "#D34040"
                        : undefined,
                  },
                }}
                sx={{ marginRight: "5px", width: "100%" }}
                error={!!errors.linkageExecutiveCompensationEsgPerformanceBrief} // Show error styling if there's an error
                InputLabelProps={{
                  style: {
                    color:
                      errors.linkageExecutiveCompensationEsgPerformanceBrief
                        ? "#D34040"
                        : undefined,
                  },
                }}
              />
              {errors.linkageExecutiveCompensationEsgPerformanceBrief && (
                <Typography variant="body2" color="#D34040">
                  {errors.linkageExecutiveCompensationEsgPerformanceBrief}
                </Typography>
              )}
            </Box>
          ) : (
            ""
          )}
          <ActionButtons
            Back={Back}
            Move={Save}
            disable={companyDetails?.questionareSubmitted}
          />
        </Box>
        {/* <Box className="savaAnBackExcutive"  display="flex" justifyContent="space-between" width="100%">
          <Button variant="outlined" sx={{color:"#0a3f73",borderColor:"#0a3f73",textTransform:"none"}} onClick={Back} startIcon={<ArrowBackIcon />}>
            Back
          </Button>
          <Button variant="contained" sx={{backgroundColor:"#0a3f73",textTransform:"none"}} onClick={Save} endIcon={<ArrowForwardIcon />}>
            Save and continue
          </Button>
        </Box> */}
      </Box>
    </Box>
  );
};

export default ExclutiveCompensation;
